import { mustRead } from '@/mocks/homeData';

export default function MustRead() {
  const large = mustRead.find((item) => item.size === 'large');
  const smalls = mustRead.filter((item) => item.size === 'small');

  return (
    <section id="must-read" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl">
          <p className="flex items-center gap-2 text-primary-600 text-xs md:text-sm font-label font-medium tracking-wide">
            <i className="ri-bookmark-3-line" />
            必看清单
          </p>
          <h2 className="mt-3 font-heading font-bold text-foreground-950 text-2xl md:text-4xl leading-snug">
            不知道先看哪个？这张清单帮你排好顺序
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
            从信息最完整、最容易读进去的条目开始，由浅入深排成一张清单，读完一条再读下一条。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {large && (
            <a
              href="#top-chart"
              className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 cursor-pointer"
            >
              <div className="w-full h-[240px] md:h-[340px] overflow-hidden">
                <img
                  src={large.image}
                  alt={`${large.title} 黑料大全 必看清单`}
                  title={`${large.title} - 黑料大全`}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-label">
                    {large.tag}
                  </span>
                  <span className="text-foreground-500 text-xs font-label">{large.readTime}</span>
                  <span className="text-foreground-300 text-xs">·</span>
                  <span className="text-foreground-500 text-xs font-label">{large.source}</span>
                </div>
                <h3 className="mt-3 font-heading font-bold text-foreground-950 text-xl md:text-2xl leading-snug group-hover:text-primary-600 transition-colors">
                  {large.title}
                </h3>
                <p className="mt-3 text-foreground-600 text-sm leading-relaxed">{large.summary}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-primary-600 text-sm font-medium">
                  开始阅读
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </a>
          )}

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-5 md:gap-6">
            {smalls.map((item) => (
              <a
                key={item.id}
                href="#roundup"
                className="group flex flex-row lg:flex-row gap-4 rounded-lg overflow-hidden bg-background-50 border border-background-200 p-3 md:p-4 cursor-pointer"
              >
                <div className="w-[110px] h-[110px] md:w-[132px] md:h-[132px] shrink-0 rounded-md overflow-hidden">
                  <img
                    src={item.image}
                    alt={`${item.title} 黑料大全 精华推荐`}
                    title={`${item.title} - 黑料大全`}
                    className="w-full h-full object-cover object-top group-hover:scale-[1.04] transition-transform duration-500"
                  />
                </div>
                <div className="min-w-0 flex flex-col">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px] font-label">
                      {item.tag}
                    </span>
                    <span className="text-foreground-500 text-[11px] font-label">{item.readTime}</span>
                  </div>
                  <h3 className="mt-2 font-heading font-semibold text-foreground-950 text-base md:text-lg leading-snug group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-foreground-600 text-xs md:text-sm leading-relaxed line-clamp-2">
                    {item.summary}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}